import { defineComponent as _defineComponent } from 'vue'
import { vModelDynamic as _vModelDynamic, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["type"]
const _hoisted_2 = { class: "input__label" }

import { computed, onMounted, ref } from 'vue'
import IconClose from '@/components/images/IconClose.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'CustomInput',
  props: {
    class: {},
    modelValue: {},
    clearable: { type: Boolean },
    label: {},
    focus: { type: Boolean },
    type: { default: 'text' }
  },
  emits: ['update:modelValue', 'clear'],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const inputRef = ref()

const value = computed({
  get: () => props.modelValue ?? '',
  set: (value: string) => {
    emit('update:modelValue', value)
  }
})

const handleClear = () => {
  value.value = ''
  emit('clear')
  inputRef.value.focus()
}

onMounted(() => {
  if (props.focus) {
    inputRef.value?.focus()
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["input", props.class])
  }, [
    _withDirectives(_createElementVNode("input", {
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((value).value = $event)),
      ref_key: "inputRef",
      ref: inputRef,
      class: "input__field",
      type: props.type,
      placeholder: " "
    }, null, 8, _hoisted_1), [
      [_vModelDynamic, value.value]
    ]),
    _createElementVNode("label", _hoisted_2, _toDisplayString(props.label), 1),
    (props.clearable && value.value)
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          class: "receiving-search__clear",
          onClick: handleClear
        }, [
          _createVNode(IconClose)
        ]))
      : _createCommentVNode("", true)
  ], 2))
}
}

})